<div (mouseleave)="setDefaultColorBaseOnStars()" class="w-fit">
	<button class="me-2" mat-raised-button color="primary" (click)="submitStars(-1)">Brak</button>
	@for (n of numOfStarsArray(); track numOfStarsArray(); let i = $index) {
		<i
			#starEl
			(mouseenter)="setStarsColorOnHover(i)"
			class="fa-star star"
			[ngClass]="{
				fas: i < selectedStarsNumber(),
				far: i >= selectedStarsNumber(),
				'cursor-pointer': !disabled(),
			}"
			(click)="submitStars(i)"
		></i>
	}
</div>
